import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll on route change. If the URL has a hash (e.g. /how-it-works#filmmaker),
// scrolls to the matching element instead of the top. Uses requestAnimationFrame so
// the target element is guaranteed to be in the DOM when the scroll runs.
// Added in Hotfix 14.1 to fix the /how-it-works#filmmaker anchor being overridden.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Defer one frame so React has committed the new page's DOM
      requestAnimationFrame(() => {
        const id = hash.slice(1); // strip leading '#'
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Hash targets an element that doesn't exist on this page; fall back to top
          window.scrollTo({ top: 0, behavior: 'instant' });
        }
      });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}
